import React from 'react';
import Nav from './components/Nav';
import About from './components/About';
import Projects from './components/Projects';
import Contact from './components/Contact';
import Background from './components/Background';
import Work from './components/Work';
import Intro from './components/Intro';
import WorkH from './components/WorkH';

function App() {
  return (
    <div className="App">
      <Background />
      <Nav />
      <Intro />
      <About />
      <WorkH />
      <Projects />
      <Contact />
    </div>
  );
}

export default App;
